import { HafSqlRow, SimulationData } from '../types';
import { HIVE_NODES } from '../constants';

export async function getHivePerMVest(): Promise<number> {
  for (const node of HIVE_NODES) {
    try {
      const response = await fetch(node, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          jsonrpc: "2.0",
          method: "condenser_api.get_dynamic_global_properties",
          params: [],
          id: 1
        }),
        signal: AbortSignal.timeout(3000)
      });
      const data = await response.json();
      if (data.result) {
        const totalHive = parseFloat(data.result.total_vesting_fund_hive);
        const totalVests = parseFloat(data.result.total_vesting_shares);
        return totalHive / (totalVests / 1000000);
      }
    } catch (e) { continue; }
  }
  return 559.20; 
}

export async function getHivePriceUsd(): Promise<number> {
  try {
    const response = await fetch('https://api.coingecko.com/api/v3/simple/price?ids=hive&vs_currencies=usd', {
      signal: AbortSignal.timeout(4000)
    });
    const data = await response.json();
    return data.hive?.usd || 0.35; // Fallback to a reasonable default if API fails
  } catch (e) {
    console.warn("CoinGecko Fetch Failed, using fallback price.");
    return 0.35;
  }
}

export async function executeHafQuery(_endpoint?: string, watchlist?: string): Promise<SimulationData> {
  const start = performance.now();
  const [hpm, priceUsd] = await Promise.all([
    getHivePerMVest(),
    getHivePriceUsd()
  ]);
  
  let rows: HafSqlRow[] = [];
  let executionTime = "0ms";

  try {
    const response = await fetch('/api/data', {
      method: 'GET',
      headers: { 
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      signal: AbortSignal.timeout(15000) 
    });

    const contentType = response.headers.get("content-type");
    if (!response.ok || !contentType || !contentType.includes("application/json")) {
       throw new Error("SERVER_CONGESTION: The HAF Bridge is currently under high pressure.");
    }

    const data = await response.json();

    if (data.error) {
      throw new Error(data.message || "HAF_INTERNAL_ERROR");
    }

    rows = data.rows || [];
    executionTime = data.executionTime || "0ms";
  } catch (err: any) {
    console.warn("HAF Bridge Request Failed:", err.message);
    if (err.message.includes("Unexpected token") || err.name === 'AbortError') {
       throw new Error("NETWORK_STALL: The HAF node at mahdiyari.info is temporarily unavailable.");
    }
    throw err;
  }

  if (watchlist) {
    const watchListArray = watchlist.split(',').map(s => s.trim().replace('@','')).filter(Boolean);
    if (watchListArray.length > 0) {
      rows = rows.filter(r => watchListArray.includes(r.account));
    }
  }

  const end = performance.now();
  return {
    rows,
    query: "HAF_AUDIT_SYNC",
    executionTime: executionTime !== "0ms" ? executionTime : `${(end - start).toFixed(0)}ms`,
    hivePerMVest: hpm,
    hivePriceUsd: priceUsd,
    aggregates: calculateAggregates(rows, hpm)
  };
}

function calculateAggregates(rows: HafSqlRow[], hpm: number) {
  let totalRemainingHive = 0;
  let totalWeeklyHive = 0;
  
  rows.forEach(row => {
    totalRemainingHive += (parseFloat(row.remaining_mvests as any) || 0) * hpm;
    totalWeeklyHive += (parseFloat(row.rate_mvests as any) || 0) * hpm;
  });

  return {
    totalRemainingHive,
    totalWeeklyHive,
    totalAccounts: rows.length
  };
}